import getEnv from '@clearscore-group/lib.helpers.envs';

export default {
    international: {
        baseURL: getEnv('INTERNATIONAL_API_DOMAIN'),
        responseType: 'json',
    },
};
